import {
  HomeIcon,
  DocumentArrowDownIcon,
  PlusCircleIcon,
  ArchiveBoxIcon,
  BuildingStorefrontIcon,
  KeyIcon,
  BuildingOffice2Icon,
  ArrowPathIcon,
  TruckIcon,
  CalculatorIcon,
  PaperAirplaneIcon,
  ExclamationTriangleIcon,
  RectangleStackIcon,
  QrCodeIcon,
  PuzzlePieceIcon,
  ViewColumnsIcon,
  DocumentTextIcon,
  WrenchScrewdriverIcon,
  UserCircleIcon,
  FingerPrintIcon,
  ClockIcon,
  ArrowUturnLeftIcon,
} from '@heroicons/react/24/outline'
import { MenuItem } from '../types/layout'

/**
 * Configuración centralizada de todos los menús del sidebar
 * Esta estructura permite fácilmente agregar, modificar o eliminar menús
 */
export const menuConfig: MenuItem[] = [
  {
    id: 'home',
    label: 'Inicio',
    icon: HomeIcon,
    path: '/home',
  },
  {
    id: 'cotizaciones',
    label: 'Cotizaciones',
    icon: DocumentArrowDownIcon,
    path: '/cotizaciones',
    permission: 'view_cotizaciones',
    submenu: [
      {
        id: 'create-cotizacion',
        label: 'Crear Cotización',
        icon: PlusCircleIcon,
        path: '/cotizaciones/new',
        permission: 'manage_cotizaciones',
      },
      {
        id: 'view-cotizaciones',
        label: 'Ver Cotizaciones',
        icon: ArchiveBoxIcon,
        path: '/cotizaciones',
      },
    ],
  },
  {
    id: 'orders',
    label: 'Pedidos',
    icon: BuildingStorefrontIcon,
    path: '/orders',
    submenu: [
      {
        id: 'create-order',
        label: 'Crear',
        icon: PlusCircleIcon,
        path: '/orders/new',
        permission: 'create_orders',
      },
      {
        id: 'view-orders',
        label: 'Ver Pedidos',
        icon: ArchiveBoxIcon,
        path: '/orders',
        permission: 'view_orders',
      },
      {
        id: 'verify-transactions',
        label: 'Verificar Transacción',
        icon: KeyIcon,
        path: '/orders/verify-transactions',
        permission: 'verify_transactions',
      },
      {
        id: 'entrega-pdv',
        label: 'Entrega PDV',
        icon: BuildingOffice2Icon,
        path: '/orders/entrega-pdv',
        permission: 'entrega_pdv',
      },
      {
        id: 'despachos-bodega',
        label: 'Despachos bodega',
        icon: RectangleStackIcon,
        path: '/orders/despachos-bodega',
        permission: 'manage_despachos_bodega',
      },
      {
        id: 'sync-homecenter',
        label: 'Sincronizar HC',
        icon: ArrowPathIcon,
        path: '/orders/sync-homecenter',
        permission: 'sync_homecenter',
      },
    ],
  },
  {
    id: 'envios',
    label: 'Envíos',
    icon: TruckIcon,
    path: '/envios',
    permission: 'view_envios',
    submenu: [
      {
        id: 'create-envio',
        label: 'Crear Envío',
        icon: TruckIcon,
        path: '/envios/pending',
        permission: 'manage_envios',
      },
      {
        id: 'cotizar-envio',
        label: 'Cotizar Envío',
        icon: CalculatorIcon,
        path: '/envios/liquidar',
        permission: 'cotizar_envio',
      },
      {
        id: 'seguimiento-envios',
        label: 'Seguimiento Envíos',
        icon: PaperAirplaneIcon,
        path: '/envios/seguimiento',
        permission: 'seguimiento_envios',
      },
      {
        id: 'cancelar-envios',
        label: 'Cancelar Envíos',
        icon: ExclamationTriangleIcon,
        path: '/envios/cancelar',
        permission: 'cancelar_envios',
      },
    ],
  },
  {
    id: 'fulfillment',
    label: 'Fulfillment',
    icon: RectangleStackIcon,
    path: '/fulfillment',
    permission: 'view_bodega',
    submenu: [
      {
        id: 'empacado',
        label: 'Cambiar a Empacado',
        icon: RectangleStackIcon,
        path: '/fulfillment/empacado',
        permission: 'manage_empacado',
      },
      {
        id: 'enviado',
        label: 'Cambiar a Enviado',
        icon: PaperAirplaneIcon,
        path: '/fulfillment/enviado',
        permission: 'manage_enviado',
      },
      {
        id: 'picking-iniciado',
        label: 'Cambiar a Picking Iniciado',
        icon: PaperAirplaneIcon,
        path: '/fulfillment/picking-iniciado',
        permission: 'manage_piking_iniciado',
      },
      {
        id: 'bodega-devolucion',
        label: 'Cambiar a Bodega Devolución',
        icon: ArrowUturnLeftIcon,
        path: '/fulfillment/bodega-devolucion',
        permission: 'manage_bodega_devolucion',
      },
      {
        id: 'exportar',
        label: 'Exportar Pedidos',
        icon: DocumentArrowDownIcon,
        path: '/fulfillment/exportar',
        permission: 'manage_export',
      },
    ],
  },
  {
    id: 'products',
    label: 'Productos',
    icon: ArchiveBoxIcon,
    path: '/products',
    permission: 'view_products',
    submenu: [
      {
        id: 'create-product',
        label: 'Crear Producto',
        icon: ArchiveBoxIcon,
        path: '/products/new',
        permission: 'manage_products',
      },
      {
        id: 'view-products',
        label: 'Ver Productos',
        icon: ArchiveBoxIcon,
        path: '/products',
      },
/*       {
        id: 'marketplace',
        label: 'Productos MKP',
        icon: ShoppingBagIcon,
        path: '/products/marketplace',
        submenu: [
          {
            id: 'falabella',
            label: 'Falabella',
            icon: ShoppingBagIcon,
            path: '/falabella',
            // Nota: Este item usa un icono personalizado (img) que se manejará en el componente
          },
          {
            id: 'mercadolibre',
            label: 'MercadoLibre',
            icon: ShoppingBagIcon,
            path: '/products/marketplace',
            // Nota: Este item usa un icono personalizado (img) que se manejará en el componente
          },
        ],
      }, */
      {
        id: 'import-products',
        label: 'Importar productos',
        icon: DocumentArrowDownIcon,
        path: '/products/import',
        permission: 'manage_products',
      },
      {
        id: 'qr-products',
        label: 'QR Productos',
        icon: QrCodeIcon,
        path: '/qr-list',
        permission: 'view_qr',
      },
    ],
  },
  {
    id: 'erp',
    label: 'ERP',
    icon: PuzzlePieceIcon,
    path: '/erp',
    permission: 'view_erp',
    submenu: [
      {
        id: 'comparative-table',
        label: 'Tabla Comparativa',
        icon: ViewColumnsIcon,
        path: '/erp/comparative-table',
        permission: 'view_comparative_table',
      },
      {
        id: 'remisiones-sku',
        label: 'Remisiones por SKU',
        icon: DocumentTextIcon,
        path: '/erp/remisiones-sku',
        permission: 'view_remisiones_por_sku',
      },
    ],
  },
  {
    id: 'settings',
    label: 'Ajustes',
    icon: WrenchScrewdriverIcon,
    path: '/settings',
    permission: 'view_settings',
    submenu: [
      {
        id: 'users',
        label: 'Usuarios',
        icon: UserCircleIcon,
        path: '/settings/users',
      },
      {
        id: 'permissions',
        label: 'Permisos',
        icon: KeyIcon,
        path: '/settings/permissions',
        permission: 'view_permissions',
      },
      {
        id: 'mercadolibre-token',
        label: 'Token ML',
        icon: FingerPrintIcon,
        path: '/settings/mercadolibre-token',
      },
      {
        id: 'cron-tasks',
        label: 'Tareas Cron',
        icon: ClockIcon,
        path: '/settings/cron-tasks',
        permission: 'view_settings',
      },
      {
        id: 'errors',
        label: 'Errores',
        icon: ExclamationTriangleIcon,
        path: '/errors',
        permission: 'view_errors',
      },
    ],
  },
]

/**
 * Rutas que deben mantener el sidebar colapsado automáticamente
 */
export const AUTO_COLLAPSE_ROUTES = ['/envios/pending']

/**
 * Rutas que deben auto-abrir sus menús padre
 */
export const AUTO_OPEN_MENUS: Record<string, string[]> = {
  '/envios/pending': ['orders'],
  '/falabella': ['products', 'marketplace'],
  '/products/marketplace': ['products', 'marketplace'],
}

/**
 * Iconos personalizados para items específicos (que no son de Heroicons)
 */
export const CUSTOM_ICONS: Record<string, { src: string; alt: string }> = {
  falabella: {
    src: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltde5263bea5336415/Logo%20favicon@144px.png',
    alt: 'Falabella',
  },
  mercadolibre: {
    src: 'https://http2.mlstatic.com/frontend-assets/ml-web-navigation/ui-navigation/5.21.22/mercadolibre/favicon.svg',
    alt: 'MercadoLibre',
  },
}

